import React, { useState, useEffect, useCallback } from 'react';
import { MotifButton, MotifChip } from '@ey-xd/motif-react';
import { getOpportunitiesDetails, submitPlOpportunity } from '@services/pursuitLeaderServices';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  Current_User,
  Loading_Modal_State,
  PL_Commit_State,
  PursuitLeaderTableRowDataState,
  Quaterly_OP_Details_State,
  Recoil_All_Accounts_Quarter_State,
  Recoil_Quarter_State,
  Refresh_Pl_Sidebar_Data,
  System_Date_Time_State,
  Pl_Submit_Success_Modal_State,
  Pl_Failure_Modal_State,
  Is_Baddata_Available,
  Country_Name_State,
  Refresh_Pills_Status_State,
  Is_Opps_Bad_Data_Available_State,
  Submission_Failure,
} from '@recoil/recoil';
import { dateFormatMonth, structureMonth } from '@util/commonUtil';
import {
  QuarterTitle,
  SubHeaderContainer,
  SubmitButtonContainer,
  QuarterDates,
  ChipContainer,
  SubHeaderTitle,
} from '@components/atoms/subHeaderText/subHeader.styles';
import {
  BUTTON_TITLE,
  DATA_MISMATCH_ERROR,
  PAGE,
  SOURCE,
  LOGOUT_SCREEN,
} from '@constants/commonConstants';
import SuccessTransactionModal from '@organisms/modals/SuccessTransactionModal';
import FailureTransactionModal from '@organisms/modals/failureTransactionModal';
import CustomErrorModal from '@organisms/modals/customErrorModal';
import { appInsights } from '@services/appInsightsService';
import {
  QuaterlyDetailsChangeKeys,
  getAlertBarDetails,
  getCrmUpdateList,
  isCurrentUserExist,
  isBadDataAvailable,
  logError,
  getCrmQuarterlyResponseData,
} from '@util/commonFunctions';
import {
  getForecastSubmittedStatus,
  getLogOutStatus,
  getSystemDateTime,
} from '@services/commonServices';
import LoadingModal from '@organisms/modals/loadingModal';
import { useNavigate } from 'react-router-dom';
import { hasSystemTimePassed } from '../../../util/commonUtil';

const SubHeaderPL = () => {
  const [customErrorMessage, setCustomErrorMessage] = useState({
    show: false,
    headerText: undefined,
    message: undefined,
    args: undefined,
  });
  const quarterData = useRecoilValue(Recoil_Quarter_State);

  const setPlCommitData = useSetRecoilState(PL_Commit_State);
  const plQuaterlyDetails = useRecoilValue(Quaterly_OP_Details_State);

  const [forecastStatus, setForecastStatus] = useState({}); // eslint-disable-line
  const [showSubmitConfirmationModal, setShowSubmitConfirmationModal] = useRecoilState(
    Pl_Submit_Success_Modal_State,
  );
  const [showFailureSubmitModal, setShowFailureSubmitModal] =
    useRecoilState(Pl_Failure_Modal_State);
  const currentUser = useRecoilValue(Current_User);

  const allAccountsQuarterData = useRecoilValue(Recoil_All_Accounts_Quarter_State);

  const [monthChipInfo, setMonthChipInfo] = useState({});

  const [systemDateTime, setSystemDateTime] = useRecoilState(System_Date_Time_State);

  const [currentPLRowData, setCurrentPLRowData] = useRecoilState(PursuitLeaderTableRowDataState);
  const [plRowData, setPlRowData] = useRecoilState(PursuitLeaderTableRowDataState);

  const setRefreshPLSidebarData = useSetRecoilState(Refresh_Pl_Sidebar_Data);
  const [showLoadingModal, setShowLoadingModal] = useRecoilState(Loading_Modal_State);

  const setIsBaddataFound = useSetRecoilState(Is_Baddata_Available);
  const countryName = useRecoilValue(Country_Name_State);

  const isOppsBadDataAvailable = useRecoilValue(Is_Opps_Bad_Data_Available_State);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [, setShowSubmissionFailureModal] = useRecoilState(Submission_Failure);
  const [refreshPillStatus, setRefreshPillStatus] = useRecoilState(Refresh_Pills_Status_State);

  let alertStatusDetails;
  let updatedOpportunities;

  const navigate = useNavigate();

  const fetchForecastStatus = async () => {
    appInsights.trackTrace({
      message: JSON.stringify({
        message: 'Entering fetchForecastStatus for PL',
        userId: localStorage.getItem('userEmail'),
        source: SOURCE.FRONTEND,
      }),
      severityLevel: 1, // 1 represents response log
    });
    if (!quarterData) {
      appInsights.trackTrace({
        message: JSON.stringify({
          message: 'No quarterly data in fetchForecastStatus for PL',
          userId: localStorage.getItem('userEmail'),
          source: SOURCE.FRONTEND,
        }),
        severityLevel: 1, // 1 represents response log
      });
      return; // or handle the absence of quarterData accordingly
    }

    const reqPayload = {
      email: currentUser.email,
      role: currentUser.role,
      month: quarterData.month.toLowerCase(),
      year: quarterData.fiscal_year,
      accountId: currentUser.account_id,
    };
    appInsights.trackTrace({
      message: JSON.stringify({
        message: `Making the API call getForecastSubmittedStatus for PL with payload ${JSON.stringify(reqPayload)}`,
        userId: localStorage.getItem('userEmail'),
        source: SOURCE.FRONTEND,
      }),
      severityLevel: 1, // 1 represents response log
    });
    const status = await getForecastSubmittedStatus(reqPayload);
    setForecastStatus({
      monthly_submission: status.monthly_submission,
    });
  };

  useEffect(() => {
    fetchForecastStatus();
  }, []);

  useEffect(() => {
    if (isOppsBadDataAvailable !== null) {
      const IsSubmitDisabledStatus =
        !(TodaysDate >= personaStartDateCheck && TodaysDate <= personaCloseDateCheck) ||
        isOppsBadDataAvailable ||
        (localStorage.getItem('isSuperUser') == 'true' &&
          localStorage.getItem('targetUserEmail') !== 'null')
          ? true // Disable
          : false; // Enable

      setIsSubmitDisabled(IsSubmitDisabledStatus);
    }
  }, [isOppsBadDataAvailable]);

  const quarter = quarterData ? structureMonth(quarterData.quarter) : '';
  const fullMonth = quarterData ? structureMonth(quarterData.month) : '';
  const currentYear = quarterData ? quarterData.fiscal_year : '';
  const StartDate = quarterData ? dateFormatMonth(quarterData.current_month_start_date) : '';
  const EndDate = quarterData ? dateFormatMonth(quarterData.next2next_month_end_date) : '';
  const startMonth = quarterData ? quarterData.month : '';
  const endMonth = quarterData ? quarterData.next2next_month : '';
  const TodaysDate = systemDateTime ? new Date(systemDateTime) : new Date();
  const personaStartDateCheck = quarterData ? new Date(quarterData.persona_startdate) : new Date();
  const personaCloseDateCheck = quarterData ? new Date(quarterData.persona_closedate) : new Date();
  let currentDateTime;

  const checkforUpdatedOppotunitiesData = useCallback(() => {
    appInsights.trackTrace({
      message: JSON.stringify({
        message: 'Entering checkforUpdatedOppotunitiesData for PL',
        userId: localStorage.getItem('userEmail'),
        source: SOURCE.FRONTEND,
      }),
      severityLevel: 1, // 1 represents response log
    });
    return new Promise(async (resolve, reject) => {// eslint-disable-line
      try {
        if (localStorage.getItem('modifiedSystemDateAndTime')) {
          currentDateTime = localStorage.getItem('modifiedSystemDateAndTime');
        } else {
          const apiDateTime = await getSystemDateTime(localStorage.getItem('userEmail'));
          currentDateTime = apiDateTime?.date;
        }

        setSystemDateTime(currentDateTime);
        appInsights.trackTrace({
          message: JSON.stringify({
            message: `Making API call for getOpportunitiesDetails for PL using ${currentDateTime} & ${currentUser.email}`,
            userId: localStorage.getItem('userEmail'),
            source: SOURCE.FRONTEND,
          }),
          severityLevel: 1, // 1 represents response log
        });

        const getOpportunitiesDetailsAPI = await getOpportunitiesDetails(
          currentUser.email,
          currentDateTime,
        );
        const updateOpportunites = getOpportunitiesDetailsAPI.opportunities;
        appInsights.trackTrace({
          message: JSON.stringify({
            message: `getOpportunitiesDetails response for PL is ${JSON.stringify(updateOpportunites)}`,
            userId: localStorage.getItem('userEmail'),
            source: SOURCE.FRONTEND,
          }),
          severityLevel: 1, // 1 represents response log
        });
        const badDataStatus = await isBadDataAvailable(updateOpportunites);
        setIsBaddataFound(badDataStatus);
        setShowLoadingModal(true);
        appInsights.trackTrace({
          message: JSON.stringify({
            message:
              'Setting sessionStorage CrmUpdatedOpportunities from getOpportunitiesDetails for PL',
            userId: localStorage.getItem('userEmail'),
            source: SOURCE.FRONTEND,
          }),
          severityLevel: 1, // 1 represents response log
        });
        sessionStorage.setItem('CrmUpdatedOpportunities', JSON.stringify(updateOpportunites));

        if (getOpportunitiesDetailsAPI.isBadDataAvailable) {
          //check if the opps data is bad data
          appInsights.trackTrace({
            message: JSON.stringify({
              message: 'CrmUpdatedOpportunities from getOpportunitiesDetails has badData for PL',
              userId: localStorage.getItem('userEmail'),
              source: SOURCE.FRONTEND,
            }),
            severityLevel: 1, // 1 represents response log
          });
          setIsSubmitDisabled(!isSubmitDisabled);
          resolve({ isDataChanged: true, newPlRowData: updateOpportunites });
        } else if (updateOpportunites.length !== currentPLRowData.length) {
          //checks if count of opps in new and old list are same if not there is mismatch
          resolve({ isDataChanged: true, newPlRowData: updateOpportunites });
        } else {
          const opportunityMap = new Map(
            updateOpportunites.map(element => [element.opportunity_id, element]),
          );
          currentPLRowData.forEach(element => {
            if (opportunityMap.has(element.opportunity_id)) {
              appInsights.trackTrace({
                message: JSON.stringify({
                  message: `Processing currentPLRowData's opportunityId: ${element.opportunity_id}`,
                  userId: localStorage.getItem('userEmail'),
                  source: SOURCE.FRONTEND,
                }),
                severityLevel: 1, // 1 represents response log
              });
              //opp exists in map hence compare the opp data to check mismatch
              const oldData = element;
              const newData = opportunityMap.get(element.opportunity_id);
              if (
                newData.tov !== oldData.tov ||
                newData.awd !== oldData.awd ||
                newData.fiscal_month !== oldData.fiscal_month ||
                newData.fiscal_year !== oldData.fiscal_year
              ) {
                appInsights.trackTrace({
                  message: JSON.stringify({
                    message: `Data changed in currentPLRowData's processing & setting opportunities as ${JSON.stringify(updateOpportunites)}`,
                    userId: localStorage.getItem('userEmail'),
                    source: SOURCE.FRONTEND,
                  }),
                  severityLevel: 1, // 1 represents response log
                });
                //check for mismatch in data
                resolve({ isDataChanged: true, newPlRowData: updateOpportunites });
              }
            } else {
              appInsights.trackTrace({
                message: JSON.stringify({
                  message: `currentPLRowData is not matching with that of API's response & setting opportunities as ${JSON.stringify(updateOpportunites)}`,
                  userId: localStorage.getItem('userEmail'),
                  source: SOURCE.FRONTEND,
                }),
                severityLevel: 1, // 1 represents response log
              });
              //opp does not exist in the map hence mismatch
              resolve({ isDataChanged: true, newPlRowData: updateOpportunites });
            }
          });
          resolve({ isDataChanged: false });
        }
      } catch (error) {
        reject(error);
      }
    });
  }, [getOpportunitiesDetails, currentPLRowData]);

  const handlePostData = async () => {
    appInsights.trackTrace({
      message: JSON.stringify({
        message: 'Entering handlePostData for PL',
        userId: localStorage.getItem('userEmail'),
        source: SOURCE.FRONTEND,
      }),
      severityLevel: 1, // 1 represents response log
    });
    appInsights.trackTrace({
      message: JSON.stringify({
        message: `Calling isCurrentUserExist with ${countryName} handlePostData for PL`,
        userId: localStorage.getItem('userEmail'),
        source: SOURCE.FRONTEND,
      }),
      severityLevel: 1, // 1 represents response log
    });

    const isUserExist = await isCurrentUserExist(countryName);

    if (isUserExist) {
      appInsights.trackTrace({
        message: JSON.stringify({
          message: 'User exists for PL, proceeding with next steps',
          userId: localStorage.getItem('userEmail'),
          source: SOURCE.FRONTEND,
        }),
        severityLevel: 1, // 1 represents response log
      });
      const isSystemTimePassed = hasSystemTimePassed(personaCloseDateCheck);

      if (isSystemTimePassed) {
        appInsights.trackTrace({
          message: JSON.stringify({
            message: 'System Time passed and user cannot submit PL opportunities',
            userId: localStorage.getItem('userEmail'),
            source: SOURCE.FRONTEND,
          }),
          severityLevel: 1, // 1 represents response log
        });
        setShowSubmissionFailureModal(true);
      } else {
        appInsights.trackTrace({
          message: JSON.stringify({
            message: 'System Time not passed and user can submit PL opportunities',
            userId: localStorage.getItem('userEmail'),
            source: SOURCE.FRONTEND,
          }),
          severityLevel: 1, // 1 represents response log
        });
        setShowLoadingModal(true);
        try {
          const { isDataChanged, newPlRowData } = await checkforUpdatedOppotunitiesData();
          if (isDataChanged) {
            appInsights.trackTrace({
              message: JSON.stringify({
                message: 'currentPLRowData is not matching with that of API response ',
                userId: localStorage.getItem('userEmail'),
                source: SOURCE.FRONTEND,
              }),
              severityLevel: 1, // 1 represents response log
            });
            updatedOpportunities = newPlRowData.map(newItem => {
              const matchingItem = plRowData.find(
                oldItem => oldItem.opportunity_id === newItem.opportunity_id,
              );
              if (matchingItem) {
                newItem.commit_status = matchingItem.commit_status;

                return {
                  ...newItem,
                };
              } else {
                return newItem;
              }
            });
            setShowLoadingModal(false); // Hide Loading Modal
            setCustomErrorMessage({
              //showing this modal when data mismatch
              show: true,
              headerText: DATA_MISMATCH_ERROR.title,
              message: DATA_MISMATCH_ERROR.message,
              closeButtonText: DATA_MISMATCH_ERROR.buttonText,
              args: newPlRowData,
            });
            return;
          }
        } catch (error) {
          appInsights.trackTrace({
            message: JSON.stringify({
              message: 'checkforUpdatedOppotunitiesData is failed with error',
              error: error,
              userId: localStorage.getItem('userEmail'),
              source: SOURCE.FRONTEND,
            }),
            severityLevel: 3, // 1 represents response log
          });
          logError('checkforUpdatedOppotunitiesData', error);
          return;
        }
        const MONTH = quarterData.month;
        const YEAR = quarterData.fiscal_year;
        const QUARTER = quarterData.quarter;
        const snapDates = {
          fiscal_month_startdate: quarterData?.current_month_start_date,
          fiscal_month_enddate: quarterData?.current_month_end_date,
          fiscal_quarter_startdate: quarterData?.quarter_start_date,
          fiscal_quarter_enddate: quarterData?.quarter_end_date,
        };

        const rollingDates = {
          fiscal_month_startdate: quarterData?.quarter_start_date,
          fiscal_month_enddate: quarterData?.quarter_end_date,
        };
        appInsights.trackTrace({
          message: JSON.stringify({
            message: `Calling getCrmQuarterlyResponseData with ${JSON.stringify(plQuaterlyDetails)} and ${JSON.stringify(plRowData)} for PL`,
            userId: localStorage.getItem('userEmail'),
            source: SOURCE.FRONTEND,
          }),
          severityLevel: 1, // 1 represents response log
        });
        const crmQuaterlyResponseList = getCrmQuarterlyResponseData(plQuaterlyDetails, plRowData);

        appInsights.trackTrace({
          message: JSON.stringify({
            message: `crmQuaterlyResponseList from getCrmQuarterlyResponseData is ${JSON.stringify(crmQuaterlyResponseList)} with ${JSON.stringify(plQuaterlyDetails)} and ${JSON.stringify(plRowData)} for PL`,
            userId: localStorage.getItem('userEmail'),
            source: SOURCE.FRONTEND,
          }),
          severityLevel: 1, // 1 represents response log
        });
        const crm_full_res = plRowData.map(item => {
          return {
            commit: item.commit_status,
            opportunity_id: item.opportunity_id,
          };
        });
        const crm_update_list = getCrmUpdateList(plRowData);

        const REQ_BODY = {
          forecast_table_details: {
            forecast_id: currentUser.email,
          },
          crm_update: crm_update_list,
          snap_dates: snapDates,
          rolling_dates: rollingDates,
          crm_response: crm_full_res,
          email: currentUser.email,
          role: currentUser.role,
          performing_segment: null,
          month: MONTH,
          year: YEAR,
          quarter: QUARTER,
        };

        REQ_BODY.crm_quaterly_response = QuaterlyDetailsChangeKeys(crmQuaterlyResponseList);
        JSON.stringify(REQ_BODY);

        try {
          appInsights.trackTrace({
            message: JSON.stringify({
              message: `Making API call submitPlOpportunity with payload ${JSON.stringify(REQ_BODY)}`,
              userId: localStorage.getItem('userEmail'),
              source: SOURCE.FRONTEND,
            }),
            severityLevel: 1, // 1 represents response log
          });
          const response = await submitPlOpportunity(REQ_BODY);

          if (response === true) {
            setShowLoadingModal(false); // Hide Loading Modal
            setShowSubmitConfirmationModal(true); // Showing Success Modal When Response is 200
            setPlCommitData({});
            sessionStorage.removeItem('CrmUpdatedOpportunities');
            appInsights.trackTrace({
              message: JSON.stringify({
                message: `PL successfully submitted opportunitis for ${QUARTER} ${MONTH} ${YEAR}  `,
                userId: localStorage.getItem('userEmail'),
                source: SOURCE.FRONTEND,
              }),
              severityLevel: 1, // 1 represents response log
            });
          } else {
            setShowLoadingModal(false); // Hide Loading Modal
            setShowFailureSubmitModal(true); // Showing Error Modal if any submit APIs Fail
          }
        } catch (error) {
          setShowLoadingModal(false); // Hide Loading Modal
          setShowFailureSubmitModal(true); // Showing Error Modal for any other error
          appInsights.trackTrace({
            message: JSON.stringify({
              message: `Error while submitting pl opportunities: ${error}  `,
              userId: localStorage.getItem('userEmail'),
              source: SOURCE.FRONTEND,
            }),
            severityLevel: 3, // 3 represents failure
          });
        }
      }
    } else {
      getLogOutStatus(localStorage.getItem('userEmail'))
        .then(() => {
          localStorage.clear();
          sessionStorage.clear();
          navigate('/logout', {
            state: {
              TITLE: LOGOUT_SCREEN.HEADER_TITLE,
              DESCRIPTION: LOGOUT_SCREEN.DESCRIPTION,
              BUTTON_TITLE: LOGOUT_SCREEN.BUTTON_TITLE,
            },
          });
        })

        .catch(error => {
          appInsights.trackTrace({
            message: JSON.stringify({
              message: `Error while submitting pl opportunities: ${error}  `,
              userId: localStorage.getItem('userEmail'),
              source: SOURCE.FRONTEND,
            }),
            severityLevel: 3, // 3 represents failure
          });
        });
    }
  };

  const getChip = () => {
    return (
      <ChipContainer>
        {Object.keys(monthChipInfo).length !== 0 ? (
          <MotifChip variant={monthChipInfo.chipVariant} type={monthChipInfo.chipType}>
            {monthChipInfo.chipTitle}
          </MotifChip>
        ) : null}
      </ChipContainer>
    );
  };

  const renderQuarterInfo = () => {
    appInsights.trackTrace({
      message: JSON.stringify({
        message: 'Entering renderQuarterInfo for PL',
        userId: localStorage.getItem('userEmail'),
        source: SOURCE.FRONTEND,
      }),
      severityLevel: 1, // 1 represents response log
    });
    if (quarterData && quarterData.current_month_start_date === quarterData.quarter_start_date) {
      return (
        <SubHeaderTitle>
          <QuarterTitle>
            {fullMonth} | FY {currentYear}
            {getChip()}
          </QuarterTitle>

          <QuarterDates>
            Forecast Submission for {startMonth}-{endMonth} & {quarter} ({StartDate} - {EndDate})
          </QuarterDates>
        </SubHeaderTitle>
      );
    } else {
      return (
        <SubHeaderTitle>
          <QuarterTitle>
            {fullMonth} FY {currentYear}
            {getChip()}
          </QuarterTitle>

          <QuarterDates>
            Forecast Submission for {startMonth}-{endMonth} ({StartDate} - {EndDate})
          </QuarterDates>
        </SubHeaderTitle>
      );
    }
  };

  useEffect(() => {
    if (quarterData !== null && currentUser !== null && allAccountsQuarterData !== null) {
      getMotifChip();
    }
  }, [quarterData, currentUser, allAccountsQuarterData, refreshPillStatus]);

  const getMotifChip = async () => {
    const apiPayload = {
      email: currentUser.email,
      role: currentUser.role,
      month: quarterData.month.toLowerCase(),
      year: quarterData.fiscal_year,
      accountId: currentUser.account_id,
      read_only: localStorage.getItem('isReadOnly') === 'true' ? true : false,
    };

    alertStatusDetails = await getAlertBarDetails(
      allAccountsQuarterData[apiPayload.role],
      apiPayload,
      PAGE.FORECAST,
      systemDateTime,
    );

    setMonthChipInfo(alertStatusDetails);
  };

  return (
    <SubHeaderContainer>
      {renderQuarterInfo()}

      <SubmitButtonContainer>
        <MotifButton
          className={isSubmitDisabled ? 'disableSubmitButton' : 'submitButton'}
          onClick={handlePostData}
          disabled={isSubmitDisabled}
        >
          {BUTTON_TITLE.SUBMIT}
        </MotifButton>
        <LoadingModal showLoadingModal={showLoadingModal} />
        <SuccessTransactionModal showSubmitConfirmationModal={showSubmitConfirmationModal} />
        <FailureTransactionModal showFailureSubmitModal={showFailureSubmitModal} />
        <CustomErrorModal
          show={customErrorMessage.show}
          headerText={customErrorMessage.headerText}
          message={customErrorMessage.message}
          closeButtonText={customErrorMessage.closeButtonText}
          onClose={() => {
            setCustomErrorMessage({ show: false });
            // localStorage.removeItem("modifiedOpportunitiesData");
          }}
          onButtonClicked={() => {
            setPlRowData(updatedOpportunities);
            setRefreshPLSidebarData(true);
            setCurrentPLRowData(customErrorMessage.args);
            setCustomErrorMessage({ show: false });
            setRefreshPillStatus(!refreshPillStatus);
            // window.location.reload(); // To refresh the Page
          }}
        />
      </SubmitButtonContainer>
    </SubHeaderContainer>
  );
};

export default SubHeaderPL;
